const District = () =>
  import(
    /* webpackChunkName: "base-info-geo-district" */ '@/pages/base-info/geo/district/index.vue'
  )
const CreateDistrict = () =>
  import(
    /* webpackChunkName: "base-info-geo-district" */ '@/pages/base-info/geo/district/create.vue'
  )
const EditDistrict = () =>
  import(
    /* webpackChunkName: "base-info-geo-district" */ '@/pages/base-info/geo/district/edit.vue'
  )

export default {
  path: 'district',
  meta: {
    label: 'district',
    auth: 'district'
  },
  component: {
    name: 'District',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoGeoZone',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: District
    },
    {
      name: 'BaseInfoCreateGeoZone',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateDistrict
    },
    {
      name: 'BaseInfoEditGeoZone',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditDistrict,
      props: true
    }
  ]
}
